import { Box, colors } from '@mui/material';
import { CallLimiting } from '../../../common/reports/models/CallLimiting';
import { Interpolation, InterpolationProps } from '../../../config/i18n/components/Interpolation';

type Props = {
  limits: CallLimiting | null;
};

export const ReportCallLimiting = ({ limits }: Props) => {
  if (!limits) {
    return null;
  }

  const transElementsProps: { [key: string]: InterpolationProps } = limits.hasAllLimits()
    ? {
        limit: {
          i18nKey: 'reportCallLimiting.limitsSummary.limited',
          values: { maxCallsPerBucket: limits.getMaxCallsPerBucket(), maxCallsTotal: limits.getMaxCallsTotal() },
        },
        calls: {
          i18nKey: 'reportCallLimiting.callsSummary.limited',
          items: [{ name: 'color_light', color: 'text.secondary' }],
          values: {
            numCallsTotal: limits.getNumCallsTotal(),
            numCallsKept: limits.getNumCallsKept(),
            numCallsOverBucketLimit: limits.getNumCallsOverBucketLimit(),
            numCallsOverTotalLimit: limits.getNumCallsOverTotalLimit(),
          },
        },
        sites: {
          i18nKey: 'reportCallLimiting.sitesSummary.limited',
          items: [{ name: 'color_light', color: 'text.secondary' }],
          values: { numBuckets: limits.getNumBuckets(), numFullBuckets: limits.getNumFullBuckets() },
        },
      }
    : {
        limit: { i18nKey: 'reportCallLimiting.limitsSummary.default' },
        calls: { i18nKey: limits.getCallsLimited() ? 'reportCallLimiting.callsSummary.limitedGeneric' : 'reportCallLimiting.callsSummary.notLimited' },
      };

  return (
    <Box
      data-role="report-call-limiting"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        flexWrap: 'nowrap',
        textAlign: 'center',
        gap: 2,
        width: 1,
        borderTop: '1px solid',
        borderTopColor: 'grey.300',
        backgroundColor: colors.blueGrey[50],
        py: 1,
        px: 2,
        '& .MuiTypography-root': { fontSize: '0.9rem' },
      }}
    >
      <Interpolation {...transElementsProps.limit} />
      <Interpolation {...transElementsProps.calls} />
      {transElementsProps.sites && <Interpolation {...transElementsProps.sites} />}
    </Box>
  );
};
